(() => {
  const flashSuccess = '.alert-success';
  const flashDanger = '.alert-danger';
  const init = () => {
    $('body').on('click', flashSuccess, onClick);
    $('body').on('click', flashDanger, onClick);
    setTimeout(closeAll, 7000);
  }
  const onClick = e => {
    $(e.currentTarget).alert('close');
  }
  const closeAll = () => {
    $(flashSuccess).each((key, element) => {
      $(element).click();
    });
    $(flashDanger).each((key, element) => {
      $(element).click();
    });
  }
  $(init);
})();

